(() => {
  class PharmacyDetailsController {
    pharmacies = [];
    pharmaciesCopy = [];
    loading = false;

    constructor(Pharmacy, Users, Utils, Notifications, toastr) {
      'ngInject';

      Object.assign(this, {
        Pharmacy,
        Users,
        Utils,
        Notifications,
        toastr
      });
    }

    $onInit()
    {
      this.getAssociatedPharmacies();
    }

    getAssociatedPharmacies() {
      this.loading = true;
      this.Users.fetchAssociatedPharmacies(this.user.id).then(({
        data
      }) => {
        this.pharmacies = data;
        this.pharmaciesCopy = angular.copy(data);
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.toastr.error('Error: could not retrieve the associated pharmacies ');
      });
    }

    updatePharmacy(pharmacy) {
      const originalPharmacyDetails = this.pharmaciesCopy.find(({
        id
      }) => pharmacy.id === id);

      if (_.isEmpty(this.Utils.findDifference(originalPharmacyDetails, pharmacy))) {
        return;
      }

      pharmacy.updating = true;
      this.Pharmacy.updatePharmacy(pharmacy).then(() => {
        this.pharmaciesCopy = angular.copy(this.pharmacies);
        this.toastr.success(this.Notifications.pharmacy.updateManagerSuccess);
      }).catch(() => {
        this.toastr.error(this.Notifications.pharmacies.updateManagerFailed, 'Failed');
      }).finally(() => {
        delete pharmacy.updating;
      });
    }

  }

  PharmacyDetailsController.$inject = ["Pharmacy", "Users", "Utils", "Notifications", "toastr"];
  angular.module('pims').component('userPharmacies', {
    bindings: {
      user: '<'
    },
    controller: PharmacyDetailsController,
    controllerAs: 'vm',
    templateUrl: 'app/views/users/detail/tabs/pharmacies/pharmacy-details.tab.html'
  });
})();
